import React from 'react'

function SubscriptionAndPlan() {
  return (
    <div>SubscriptionAndPlan</div>
  )
}

export default SubscriptionAndPlan